import React, { useEffect, useState } from 'react';
import Dropdown from '../filters/Dropdown';
import AddLeaveModel from './AddLeaveModel';
import AddMemberLeave from './AddMemberLeave';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLeave,
  getMember,
  getTeams,
  removeLeave,
} from '../../../redux/MainAction';
import Swal from 'sweetalert2';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import PaginationComponent from '../filters/PaginationComponent';

const PendingList = () => {
  const dispatch = useDispatch();
  const leave = useSelector((state) => state?.Webtracker?.leave);
  const emp = useSelector((state) => state?.Webtracker?.member);
  const tms = useSelector((state) => state?.Webtracker?.teams);
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  // Function to toggle the modal visibility
  const toggleModal1 = () => {
    setIsModalOpen1(!isModalOpen1);
  };

  const [leaveData, setLeaveData] = useState([]); // Current page
  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  const today = new Date();

  const dayOfWeek = today.getDay();
  const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  const monday = new Date(today);
  monday.setDate(today.getDate() - diff);
  const sunday = new Date(today);
  sunday.setDate(today.getDate() + diff);

  const [showReset, setShowReset] = useState(false);
  const [dateRange, setDateRange] = useState('thisWeek');

  const [filters, setFilters] = useState({
    search: '',
    employeeIds: '',
    teamIds: '',
    startDate: moment(monday).format('YYYY-MM-DD'),
    endDate: moment(today).format('YYYY-MM-DD'),
  });

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRange(value);
    let start, end;
    const today = new Date();

    // Calculate the current week's Monday and Sunday
    const currentDayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const monday = new Date(today);
    monday.setDate(today.getDate() - currentDayOfWeek + 1); // Set to Monday of the current week
    const sunday = new Date(today);
    sunday.setDate(today.getDate() - currentDayOfWeek + 7); // Set to Sunday of the current week

    switch (value) {
      case 'thisWeek':
        start = monday;
        end = today; // End is today
        break;

      case 'last7days':
        const previousMonday = new Date(monday);
        previousMonday.setDate(monday.getDate() - 7); // Previous week's Monday
        const previousSunday = new Date(sunday);
        previousSunday.setDate(sunday.getDate() - 7); // Previous week's Sunday

        start = previousMonday;
        end = previousSunday;
        console.log('previousMonday:', previousMonday);
        console.log('previousSunday:', previousSunday);
        break;

      case 'last30days':
        start = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1)); // Start of the month
        end = today; // Today's date
        break;

      case 'custom':
        return;

      default:
        return;
    }

    console.log('Start Date (Final):', start.toISOString());
    console.log('End Date (Final):', end.toISOString());

    setFilters((prev) => ({
      ...prev,
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    }));
  };

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    dispatch(
      getLeave({
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        startDate: filters?.startDate,
        endDate: filters?.endDate,
      })
    );
    var data = {
      offset: 0,
      limit: 50,
    };
    dispatch(getMember());
    dispatch(getTeams(data));
  };

  const handleRemove = (id) => {
    if (id) {
      Swal.fire({
        title: 'Are you sure ?',
        text: 'You will not be able to recover this !!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove it!',
        cancelButtonText: 'No, keep it',
      }).then((Confirm) => {
        if (Confirm.isConfirmed) {
          var data = {
            id: id,
          };
          dispatch(removeLeave(data));
        }
      });
    }
  };

  useEffect(() => {
    if (leave && leave.rows) {
      setLeaveData(leave?.rows);
      setTotalPages(Math.ceil(leave?.count / itemsPerPage));
    }
  }, [leave, page]);

  const handleApply = (e) => {
    e.preventDefault();
    if (filters?.startDate && filters?.endDate) {
      const startDate = moment(filters.startDate);
      const endDate = moment(filters.endDate);

      if (startDate.isAfter(endDate)) {
        toast.error('Start date cannot be greater than End date', {
          position: 'top-right',
        });
        return;
      }
    }

    const payload = {
      offset: 0,
      limit: 10,
    };

    if (filters?.search?.trim()) {
      payload.search = filters.search.trim();
    }

    if (filters?.employeeIds) {
      payload.employeeIds = [filters.employeeIds];
    }

    if (filters?.teamIds) {
      payload.teamIds = [filters.teamIds];
    }

    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }

    // Dispatch the action with the constructed payload
    dispatch(getLeave(payload));
    setShowReset(true);
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleReset = () => {
    const payload = {
      offset: 0,
      limit: 10,
      startDate: moment(monday).format('YYYY-MM-DD'),
      endDate: moment(today).format('YYYY-MM-DD'),
    };
    setShowReset(false);

    setFilters({
      search: '',
      employeeIds: '',
      teamIds: '',
      startDate: moment(monday).format('YYYY-MM-DD'),
      endDate: moment(today).format('YYYY-MM-DD'),
    });
    dispatch(getLeave(payload));
    setDateRange('thisWeek');
  };

  //
  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center m-b-20">
        <div
          className="d-flex justify-content-start align-items-center "
          style={{ gap: '10px' }}
        >
          <div className="border rounded p-1">
            <i className="fa fa-search text-muted ml-2 font-weight-light"></i>
            <input
              className="search_bar ml-2"
              type="text"
              name="search"
              placeholder="Search"
              value={filters?.search}
              onChange={onChangeFilter}
            />
          </div>
          <div className="fillSelect">
            <i className="mdi mdi-account font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="employeeIds"
              value={filters?.employeeIds}
              onChange={onChangeFilter}
            >
              <option value={undefined}>All Members</option>
              {emp?.rows?.map((mems, idx) => (
                <option key={idx} value={mems?.id}>
                  {mems?.firstName} {mems?.lastName}
                </option>
              ))}
            </select>
          </div>
          <div className="fillSelect">
            <i className="mdi mdi-account font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="teamIds"
              value={filters?.teamIds}
              onChange={onChangeFilter}
            >
              <option value={undefined}>All Teams</option>
              {tms?.rows?.map((mems, idx) => (
                <option key={idx} value={mems?.id}>
                  {mems?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="fillSelect">
            <select
              className="form-control font-14"
              value={dateRange}
              onChange={handleDateRangeChange}
            >
              <option value="custom">Custom Date</option>
              {/* <option value="today">Today</option> */}
              <option value="thisWeek">This Week</option>
              <option value="last7days">Last Week</option>
              <option value="last30days">This month</option>
              {/* <option value="last6months">Last 6 Months</option> */}
            </select>
          </div>
          {dateRange === 'custom' && (
            <div
              className="d-flex align-items-center font-14 ml-2"
              style={{ gap: '5px' }}
            >
              <input
                type="date"
                className="form-control font-14"
                name="startDate"
                value={filters?.startDate}
                onChange={onChangeFilter}
                max={moment().format('YYYY-MM-DD')}
              />
              to
              <input
                type="date"
                className="form-control font-14"
                name="endDate"
                value={filters?.endDate}
                onChange={onChangeFilter}
                max={moment().format('YYYY-MM-DD')}
              />
            </div>
          )}
          <Button
            className="d-flex align-items-center justify-content-center"
            style={{ padding: '6px 14px' }}
            size="sm"
            color="primary"
            onClick={handleApply}
          >
            <i className="ion-ios7-search font-20"></i>
          </Button>
          {showReset ? (
            <Button
              className="d-flex align-items-center justify-content-center"
              style={{ padding: '6px 13px' }}
              size="sm"
              color="danger"
              onClick={handleReset}
            >
              <i className="mdi mdi-close font-20"></i>
            </Button>
          ) : (
            ''
          )}
        </div>
      </div>
      <AddMemberLeave open={isModalOpen1} onClose={toggleModal1} id={2} />
      <div style={{ overflow: 'auto' }}>
        <table
          id="datatable"
          className="table dt-responsive nowrap table-vertical"
          width="100%"
          cellSpacing="0"
        >
          <thead>
            <tr>
              <th>No.</th>
              <th className="text-nowrap">Members</th>
              <th className="text-nowrap">Team</th>
              <th className="text-nowrap">Policy</th>
              <th className="text-nowrap">Reason</th>
              <th className="text-nowrap">Paid</th>
              <th className="text-nowrap">Created on</th>
              <th className="text-nowrap">Created By</th>
              <th className="text-nowrap">Status</th>
              <th className="text-nowrap">Start</th>
              <th className="text-nowrap">End</th>
              <th className="text-nowrap">Total</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            {leaveData?.length > 0 ? (
              leaveData?.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                  <td className="text-nowrap">
                    {item?.leaveEmployee?.firstName}{' '}
                    {item?.leaveEmployee?.lastName}
                  </td>
                  <td>
                    <div className="mem_container">
                      {item?.teams?.length > 0
                        ? item?.teams?.map((tms, idx) => (
                            <span
                              key={idx}
                              className="table-team-name text-nowrap"
                            >
                              {tms?.name}
                            </span>
                          ))
                        : '--'}
                    </div>
                  </td>
                  <td className="text-nowrap">{item?.leavePolicyName}</td>
                  <td className="text-nowrap">{item?.reason}</td>
                  <td className="text-nowrap">
                    {item?.leavePolicyPayment === 'PAID' ? 'Yes' : 'No'}
                  </td>
                  <td>
                    <span className="text-nowrap">
                      {moment(item?.createdAt).format('YYYY-MM-DD')}
                    </span>
                  </td>
                  <td>
                    <span className="text-nowrap">
                      {item?.leaveCreatedBy?.firstName}{' '}
                      {item?.leaveCreatedBy?.lastName}
                    </span>
                  </td>
                  <td className="text-nowrap">{item?.status}</td>
                  <td className="text-nowrap">
                    {moment(item?.startDate).format('MMM Do YY')}
                  </td>
                  <td className="text-nowrap">
                    {moment(item?.endDate).format('MMM Do YY')}
                  </td>
                  <td className="text-nowrap">
                    {Math.abs(item?.leaveDuration)} Days
                  </td>
                  <td>
                    <div className="text-nowrap">
                      {/* <i
                        className="fa fa-edit (alias) font-20 text-muted "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Edit"
                        style={{ cursor: 'pointer' }}
                        // onClick={toggleModal1}
                      ></i> */}
                      <i
                        className="fa fa-trash-o font-20 text-danger ml-2"
                        style={{ cursor: 'pointer' }}
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete"
                        onClick={() => handleRemove(item?.id)}
                      ></i>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center">
                  No Records Found
                </td>
              </tr>
            )}
            {/* Add other rows as needed */}
          </tbody>
        </table>
      </div>
      <div className="mt-2">
        <PaginationComponent
          count={totalPages}
          page={page}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default PendingList;
